module.exports = __webpack_public_path__ + "static/media/cake.9452e85f.svg";